import {useState} from 'react'

import {SideCardModes, HProduceTaskIdentifiers, TaskSource} from '../../types'

import {EditDalogActionContainer} from './EditDalogActionContainer'
import {EditMachineSentryActionContainer} from './EditMachineSentryActionContainer'
import {EditOilAnalysisActionContainer} from './EditOilAnalysisActionContainer'
import {ProcessWorkOrderEditContainer} from './EditProcessWorkOrderContainer'

type Props = {
  task: HProduceTaskIdentifiers
  onClose: () => void
  isSingleEvent: boolean
  setMode: (next: SideCardModes) => void
}

export const TaskEditFactory = ({task, onClose, isSingleEvent, setMode}: Props) => {
  const [taskType, setTaskType] = useState<TaskSource | undefined>(task.source)

  switch (taskType) {
    case TaskSource.PROCESS_WORK_ORDER:
      return (
        <ProcessWorkOrderEditContainer
          task={task}
          onClose={onClose}
          isSingleEvent={isSingleEvent}
          setMode={setMode}
          onTaskTypeChange={setTaskType}
        />
      )
    case TaskSource.MACHINE_SENTRY_ACTIONS:
      return (
        <EditMachineSentryActionContainer
          task={task}
          onClose={onClose}
          setMode={setMode}
          onTaskTypeChange={setTaskType}
        />
      )
    case TaskSource.OIL_ANALYSIS_ACTIONS:
      return (
        <EditOilAnalysisActionContainer
          task={task}
          onClose={onClose}
          setMode={setMode}
          onTaskTypeChange={setTaskType}
        />
      )
    case TaskSource.DALOG_ACTIONS:
      return (
        <EditDalogActionContainer
          task={task}
          onClose={onClose}
          setMode={setMode}
          onTaskTypeChange={setTaskType}
        />
      )
    default: {
      return <div>Not implemented</div>
    }
  }
}
